/**
 * @desc 根据用户编码获取按钮
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  ObjectMap<string, Array<defs.appCenter.ButtonAggregateResponseDto>>
>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/menu/user/getButtons`, {
      method: "GET",

      ...options,
    }),
  );
}
